const Style = ({ attributes, id }) => {
    const { primaryColor, secondaryColor, darkBg, cardBg, colorTheme } = attributes;
    const isLight = colorTheme === 'light';

    const mainSl = `#${id}`;
    const blockSl = `${mainSl} .gmfBlocksWrapper`;

    return (
        <style dangerouslySetInnerHTML={{
            __html: `
            ${blockSl} {
                --gmf-primary: ${primaryColor};
                --gmf-secondary: ${secondaryColor};
                ${!isLight ? `--gmf-dark: ${darkBg};` : ''}
                ${!isLight ? `--gmf-card: ${cardBg};` : ''}
                --gmf-gradient: linear-gradient(90deg, ${primaryColor} 0%, ${secondaryColor} 100%);
            }
            ${blockSl} .gmf-btn-primary {
                background: var(--gmf-gradient);
            }
            ${blockSl} .gmf-btn-primary:hover {
                opacity: 0.9;
            }
            ${blockSl} .gmf-accent-color {
                color: ${primaryColor};
            }
            ${blockSl} .gmf-accent-bg {
                background: var(--gmf-gradient);
            }
            ${blockSl} .gmf-divider {
                background-color: ${primaryColor};
            }
            ${blockSl} .gmf-card:hover {
                border-color: ${primaryColor}4d;
            }
            ${blockSl} .gmf-tag {
                background-color: ${primaryColor}e6;
            }
            ${blockSl} .gmf-dot {
                background-color: ${primaryColor};
            }
            ${blockSl} .gmf-border-left {
                border-left-color: ${primaryColor}4d;
            }
            ${blockSl} .gmf-timeline-dot {
                background: var(--gmf-gradient);
            }
            ${blockSl} .gmf-timeline-line {
                background: linear-gradient(to bottom, ${primaryColor}, ${secondaryColor});
            }
            ${blockSl} .gmf-stat-value {
                background: var(--gmf-gradient);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
            }
            ${blockSl} .gmf-service-icon-wrap:hover {
                background-color: ${primaryColor}1a;
            }
            ${blockSl} .gmf-step-number {
                background: var(--gmf-gradient);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
            }
            ${blockSl} .gmf-navbar-logo-circle {
                background: var(--gmf-gradient);
            }
            ${blockSl} .gmf-footer-heading {
                color: ${primaryColor};
            }
            ${blockSl} .gmf-scroll-top:hover {
                color: ${primaryColor};
            }
            `
        }} />
    );
};

export default Style;
